/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationParameter } from '../models/application-parameter';
import { getApplicationParameter } from '../fn/application-parameter-controller/get-application-parameter';
import { GetApplicationParameter$Params } from '../fn/application-parameter-controller/get-application-parameter';

@Injectable({ providedIn: 'root' })
export class ApplicationParameterControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApplicationParameter()` */
  static readonly GetApplicationParameterPath = '/app-parameter/{parameterCode}';

  /**
   * This method returns the Application parameter by parameter code
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApplicationParameter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationParameter$Response(params: GetApplicationParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationParameter>> {
    return getApplicationParameter(this.http, this.rootUrl, params, context);
  }

  /**
   * This method returns the Application parameter by parameter code
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApplicationParameter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationParameter(params: GetApplicationParameter$Params, context?: HttpContext): Observable<ApplicationParameter> {
    return this.getApplicationParameter$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationParameter>): ApplicationParameter => r.body)
    );
  }

}
